// extracted by mini-css-extract-plugin
export default {"container":"adefault_container__aHfOx"};